module.exports = __webpack_public_path__ + "img/contact.d55f8a7e.jpg";